import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

const SliderTwo = () => {
  const [swiperInstance, setSwiperInstance] = useState(null);

  const goNext = () => {
    if (swiperInstance !== null) {
      swiperInstance.slideNext();
    }
  };

  const goPrev = () => {
    if (swiperInstance !== null) {
      swiperInstance.slidePrev();
    }
  };

  return (
    <section className="slider-area slider-area2">
      <div className="homepage-slide1">
        <Swiper onSwiper={setSwiperInstance}>
          <SwiperSlide>
            <div className="single-slide-item slide-bg4">
              <div className="slide-item-table">
                <div className="slide-item-tablecell">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-7">
                        <div className="slider-heading">
                          <p className="slider__meta">Welkom bij</p>
                          <h2 className="slider__title">
                            Ouders Lokaal
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>

      </div>
    </section>
  );
};

export default SliderTwo;
